import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { AddAbsenceData } from "types/SupportAgent";
import { axiosError, axiosSuccess, handleRequestError, handleRequestSuccess } from "utils/Request";

async function addAgentAbsence(data: AddAbsenceData) {
  const { data: response } = await api.post('/support/absences', data).then(axiosSuccess).catch(axiosError);
  return response;
}

export function useAddAgentAbsence() {
  const queryClient = useQueryClient();

  return useMutation((data: AddAbsenceData) => addAgentAbsence(data), {
    onSuccess: () => {
      handleRequestSuccess('Ausência cadastrada com sucesso!');
      queryClient.invalidateQueries('agent-absences');
      queryClient.invalidateQueries('support-agents');
      queryClient.invalidateQueries('support-stats');
    },
    onError: (error: AxiosError) => {
      handleRequestError(error, 'Erro ao cadastrar ausência. Tente novamente.');
    },
  });
}
